export default __webpack_public_path__ + "static/media/10b.2c2055a3.png";